import useScrollListener from '../../hooks/useScrollListener';
import Footer from '../../components/footer/footer.component';
import bgImage from '../../jpeg/pages/launch-store/33.jpg';
import { BlogContainer } from './blog.styles';

const BlogPage = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);

	return (
		<BlogContainer ref={contentRef}>
			<div className='home-scroll'>
				<div className="centered-nav">
					<span>Blog</span> | <span>Marketing</span>
				</div>
				{/* Banner Image */}
				<div className="blog-banner">
					<img src={bgImage} alt="Blog Header" />
				</div>

				{/* Main Content Section */}
				<div className="content-wrapper">
					<h1>Understanding Effective E-Commerce Marketing</h1>
					<span className='info'>Marketing | 2 days ago</span>
					{/* Large text content to allow scrolling */}
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
					{/* Add more lorem ipsum text here to make it long */}
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum 
						vestibulum. Cras venenatis euismod malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing 
						elit. Nullam non urna at sapien volutpat ultricies id nec lorem. Fusce gravida orci ut nibh 
						ornare convallis. Curabitur euismod erat vel justo viverra, at iaculis tortor facilisis.
					</p>
					{/* Repeat the above paragraph many times to create a long scrolling page */}
				</div>
			</div>

			<Footer />
		</BlogContainer>
	);
}

export default BlogPage;

